import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  makeStyles,
  Typography,
  Box,
  Grid,
  Divider,
  useMediaQuery,
  useTheme,
  Container,
  Tab,
  Tabs,
  ButtonBase,
} from "@material-ui/core";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../components/Alert";

const GET_ARTICLES = gql`
  query articles(
    $type: ArticleType
    $latest: Boolean
    $pageSize: Int
    $page: Int
  ) {
    articles(type: $type, latest: $latest, pageSize: $pageSize, page: $page) {
      count
      pageCount
      contents {
        id
        title
        imageUrl
        contents {
          id
          type
          body
        }
        createdAt
        type
      }
    }
  }
`;

export default function NewsPage() {
  const isTable = useMediaQuery("(min-width:960px)");
  useEffect(() => {
    window.scrollTo({
      top: isTable ? 900 : 0,
      behavior: "smooth",
    });
  }, [isTable]);
  return (
    <Box>
      <TitleImg />
      <ColumnTabs />
    </Box>
  );
}

//ANCHOR 標題圖片
function TitleImg() {
  const isTable = useMediaQuery("(min-width:749px)");
  const isPhone = useMediaQuery("(min-width:576px)");
  const useStyles = makeStyles((theme) => ({
    backBox: {
      position: "relative",
      height: "100%",
    },
    titleImg: {
      width: "100%",
      height: "100%",
      minHeight: "130px",
      objectFit: "contain",
    },
    text: {
      position: "absolute",
      top: isTable ? "55%" : isPhone ? "55%" : "60%",
      left: "50%",
      transform: "translate(-50%, 0)",
      textAlign: "center",
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      marginBottom: isPhone ? "25px" : "10px",
      fontSize: isTable ? "2.5rem" : isPhone ? "1.5rem" : "0.75rem",
    },
    subTitle: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      fontSize: isTable ? "1.5rem" : isPhone ? "0.75rem" : "0.5rem",
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.backBox}>
      <Box>
        <img
          src="/assets/images/News/titleBackGround.png"
          className={classes.titleImg}
        />
      </Box>
      <Box className={classes.text}>
        <Typography className={classes.title}>NEWS</Typography>
        <Typography className={classes.subTitle}>最新消息</Typography>
      </Box>
    </Box>
  );
}

//ANCHOR News  tabs

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function ColumnTabs() {
  const Alert = useAlert();
  const theme = useTheme();
  const history = useHistory();
  // 這邊
  const { id } = useParams();
  const isPhone = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:960px)");

  const useStyles = makeStyles((theme) => ({
    tabs: {
      "& .MuiTab-root": {
        padding: isPhone ? "0" : "",
      },
      "& .MuiButtonBase-root span": {
        fontSize: isTablet ? "" : "1rem",
      },
    },
    tab: {
      position: "relative",
      "&+&::before": {
        content: '""',
        position: "absolute",
        borderLeft: `1px solid ${theme.palette.secondary.main}}`,
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        height: "20px",
      },
    },
    content: {
      lineClamp: 3,
      display: "-webkit-box",
      textOverflow: "ellipsis",
      overflow: "hidden",
      "-webkit-box-orient": "vertical",
      textJustify: "inter-word",
      textAlign: "justify",
      minHeight: 72,
      marginTop: theme.spacing(2),
    },
    buttonBase: {
      padding: "0 5px",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.03)",
      },
      width: "80%",
    },
  }));
  const classes = useStyles();
  const [value, setValue] = useState(() => {
    switch (id) {
      case "report":
        return 1;
      case "glory":
        return 2;
      case "paper":
        return 3;
      default:
        return 0;
    }
  });
  const handleChange = (event, newValue) => {
    console.log(newValue);
    setValue(newValue);
  };

  const sectionName = [
    {
      section: "全部",
      tyep: null,
    },
    {
      section: "媒體報導",
      tyep: "MEDIA_COVERAGE",
    },
    {
      section: "富屋榮耀",
      tyep: "GLORY",
    },
    {
      section: "富屋豹報",
      tyep: "ANNOUNCEMENT",
    },
  ];

  const [getArticles, { data, loading }] = useLazyQuery(GET_ARTICLES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  useEffect(() => {
    const has = sectionName.find((item, index) => index === value);
    if (Boolean(has)) {
      getArticles({ variables: { type: has.tyep } });
    }
  }, [value]);

  const sectionList = useMemo(() => {
    if (Boolean(data)) {
      return [{ list: data.articles.contents }];
    } else {
      return [];
    }
  }, [data, value]);

  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
        <Grid container>
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              style={{ paddingBottom: "30px" }}
              justifyContent={isTablet ? "flex-start" : "space-between"}
              pt={2}
            >
              {/* 更改為指定 params */}
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="none"
                textColor="secondary"
                centered
                className={classes.tabs}
              >
                {sectionName.map((item, index) => {
                  return (
                    <Tab
                      className={classes.tab}
                      label={item.section}
                      value={index}
                      // {...a11yProps(index)}
                      wrapped={true}
                    />
                  );
                })}
              </Tabs>
            </Box>
          </Grid>

          {/* swipable list */}
          <Grid item container xs={12} justify="center">
            <Grid xs={12} sm={10} item>
              <Box width="100%" mx="auto">
                {/* 各panel */}
                {sectionList.map((item, index) => {
                  return (
                    <>
                      {/* <TabPanel value={value} index={index}> */}
                      <Grid container spacing={isPhone ? 0 : 6}>
                        {item.list.map((item) => {
                          return (
                            <>
                              <Grid
                                container
                                justifyContent="center"
                                spacing={2}
                                item
                                xs={12}
                                md={4}
                              >
                                {/* list item 內容 */}
                                <ButtonBase
                                  className={classes.buttonBase}
                                  style={{ paddingBottom: "10px" }}
                                  onClick={() => {
                                    history.push(
                                      `/news-content/${item.title}`,
                                      { id: item.id }
                                    );
                                  }}
                                >
                                  <Grid item xs={12} container>
                                    <Grid xs={12} item>
                                      <img
                                        src={item.imageUrl}
                                        style={{
                                          objectFit: "cover",
                                          width: "100%",
                                          maxHeight: "200px",
                                        }}
                                      />
                                      <Divider
                                        style={{
                                          margin: "1em 0",
                                          backgroundColor: "rgba(0,0,0,0.4)",
                                        }}
                                      />
                                    </Grid>
                                    {/* 中線右邊 */}
                                    <Grid container xs={12} item>
                                      <Box>
                                        <Typography variant="body2">
                                          {item.caption}
                                        </Typography>
                                        <Box my={1}>
                                          <Typography variant="subtitle1">
                                            {item.title}
                                          </Typography>
                                        </Box>
                                        <Typography
                                          variant="subtitle2"
                                          className={classes.content}
                                        >
                                          {item.content}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </ButtonBase>
                              </Grid>
                            </>
                          );
                        })}
                        {/* list 區塊 */}
                      </Grid>
                      {/* </TabPanel> */}
                    </>
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
